import { RouteLocationNormalized, Router } from "vue-router"

// Only the paths the edge middleware splits between the legacy and new renewal journeys.
const SPLIT_RENEWAL_PATH =
  /^\/(renew(\/.*)?|renew-pending|renew-complete|renew-unavailable)\/?$/

const isSplitRenewalPath = (path: string) => SPLIT_RENEWAL_PATH.test(path)

export default (router: Router) =>
  (to: RouteLocationNormalized): boolean | undefined => {
    if (!isSplitRenewalPath(to.path)) return

    const base = router.options.history.base
    const { pathname } = window.location
    const loadedPath = pathname.startsWith(base)
      ? pathname.slice(base.length)
      : pathname

    if (isSplitRenewalPath(loadedPath)) return

    window.location.assign(
      `${window.location.origin}${router.resolve(to.fullPath).href}`
    )
    return false
  }
